module.exports = __webpack_public_path__ + "img/pre_20211001_32pll.b22b5e75.png";